"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationCancellationPopup = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const roundMoney_1 = require("../../../utils/roundMoney");
const Button_1 = require("../../Button");
const Field_1 = require("../../Form/Field");
const Sub_1 = require("../../Page/Title/Sub");
const FlightPassengers_1 = require("../List/FlightPassengers");
const messages_1 = require("./messages");
require("./index.scss");
const className = 'reservation-cancellation-popup';
const ReservationCancellationPopup = (props) => {
    const { onConfirm, onCancel, total, outboundFlight, returnFlight, outboundPassengers, returnPassengers, } = props;
    const [feeValue, setFeeValue] = (0, react_1.useState)('');
    const [error, setError] = (0, react_1.useState)();
    const { formatMessage, locale } = (0, react_intl_1.useIntl)();
    const onChangeFee = (0, react_1.useCallback)((e) => {
        setError(undefined);
        setFeeValue(e.target.value);
    }, []);
    const onConfirmHandler = (0, react_1.useCallback)(() => {
        const value = parseFloat(feeValue);
        if (isNaN(value) && feeValue !== '') {
            setError([
                formatMessage(messages_1.messages.feeError),
            ]);
            return;
        }
        onConfirm(isNaN(value) ? 0 : value);
    }, [feeValue, formatMessage, onConfirm]);
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("div", { className: `${className}__container` },
            react_1.default.createElement("div", null,
                react_1.default.createElement(Sub_1.PageSubTitle, { icon: 'confirm-cancellation', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/CancellationPopup:Title', defaultMessage: 'Confirm Cancellation' }) }),
                react_1.default.createElement("div", { className: `${className}__texts` },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/CancellationPopup:DoYouWantToDelete', defaultMessage: 'Do you really want to delete this reservation?' })),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/CancellationPopup:TotalPrice', defaultMessage: 'Total Price: {total}', values: { total: `${(0, roundMoney_1.localizeMoney)(total, locale, 'Reservation/CancellationPopup')} CHF` } })))),
            react_1.default.createElement("div", { className: `${className}__reservations` },
                react_1.default.createElement("div", { className: `${className}__flight-way` },
                    react_1.default.createElement("div", { className: `${className}__subtitle` },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/CancellationPopup:OutboundTitle', defaultMessage: 'Outbound' })),
                    react_1.default.createElement(FlightPassengers_1.ReservationListFlightPassengers, { flight: outboundFlight, passengers: outboundPassengers })),
                react_1.default.createElement("div", { className: `${className}__flight-way` }, returnFlight && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: `${className}__subtitle` },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/CancellationPopup:ReturnTitle', defaultMessage: 'Return' })),
                    react_1.default.createElement(FlightPassengers_1.ReservationListFlightPassengers, { flight: returnFlight, passengers: returnPassengers }))))),
            react_1.default.createElement("div", { className: `${className}__fee` },
                react_1.default.createElement(Field_1.FormField, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/CancellationPopup:CancellationFee', defaultMessage: 'Cancellation fee' }), addon: 'CHF', value: feeValue, onChange: onChangeFee, error: error })),
            react_1.default.createElement("div", { className: `${className}__actions` },
                react_1.default.createElement("div", { className: `${className}__actions-container` },
                    react_1.default.createElement("div", { className: `${className}__action-left` },
                        react_1.default.createElement(Button_1.Button, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/Payment/Popup:Cancel', defaultMessage: 'Cancel' }), modificators: ['ascetic'], onClick: onCancel })),
                    react_1.default.createElement("div", { className: `${className}__action-right` },
                        react_1.default.createElement(Button_1.Button, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/Payment/Popup:Confirm', defaultMessage: 'Confirm' }), onClick: onConfirmHandler, modificators: ['ascetic-brand'] })))))));
};
exports.ReservationCancellationPopup = ReservationCancellationPopup;
//# sourceMappingURL=index.js.map